export default __webpack_public_path__ + "static/media/sbj-physics.9788ea75.svg";